import { render, staticRenderFns } from "./NotesModal.vue?vue&type=template&id=e1338efe"
import script from "./NotesModal.vue?vue&type=script&lang=ts"
export * from "./NotesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports